<div class="page-title-area title-img-one">
    <div class="d-table">
        <div class="d-table-cell">
            <div class="page-title-text">
                <h2>FAQ</h2>

                <ul>
                    <li><a routerLink="/">Home</a></li>
                    <li><i class="icofont-simple-right"></i></li>
                    <li>FAQ</li>
                </ul>
            </div>
        </div>
    </div>
</div>

<section class="faq-area pt-100">
     <div class="container"></div>
</section>